import React, { useState } from 'react';

const SearchToggle = ({ searchHistory, popularScenarios, onScenarioSelect }) => {
  const [activeTab, setActiveTab] = useState('recent');

  return (
    <div className="search-history-container">
      <div className="tab-buttons">
        <button 
          className={`tab-button ${activeTab === 'recent' ? 'active' : ''}`}
          onClick={() => setActiveTab('recent')}
        >
          Recent Searches
        </button>
        <button 
          className={`tab-button ${activeTab === 'popular' ? 'active' : ''}`}
          onClick={() => setActiveTab('popular')}
        >
          Popular Scenarios
        </button>
      </div>

      <div className="history-content">
        <div className="history-items">
          {activeTab === 'recent' ? (
            searchHistory.length > 0 ? (
              searchHistory.map((item, index) => (
                <button
                  key={index}
                  className="history-item"
                  onClick={() => onScenarioSelect(item.searchTerm)}
                >
                  <span className="scenario-text">{item.searchTerm}</span>
                </button>
              ))
            ) : (
              <div className="empty-state">No recent searches</div>
            )
          ) : (
            popularScenarios.length > 0 ? (
              popularScenarios.map((item, index) => (
                <button
                  key={index}
                  className="history-item"
                  onClick={() => onScenarioSelect(item.text)}
                >
                  <span className="scenario-text">{item.text}</span>
                  <span className="view-count">{item.views}</span>
                </button>
              ))
            ) : (
              <div className="empty-state">No popular scenarios</div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchToggle;